<template>
  <div class="timeout_info">
      <van-overlay :show="infoShow">
         <div class="timeout_info_wrapper">
            <div class="timeout_info_wrapper_pic">
               提示
            </div>
            <p>{{infoMsg}}</p>
            <div class="timeout_info_wrapper_btns" @click="goback">
             我知道啦
            </div>
         </div>
      </van-overlay>
  </div>
</template>

<script>
export default {
   name:"timeout-info",
   props:{
      infoShow:{
         type:Boolean
      },
      infoMsg:{
         type:String
      },
   },
   methods:{
      goback() {
         this.$emit('goback')
      },
   },
}
</script>

<style lang="scss" scoped>
.van-overlay{
   display: flex;
   justify-content: center;
   align-items: center;
   z-index: 999;
   .timeout_info_wrapper{
      width:286px;
      height:173px;
      background: url("../../assets/images/jigsaw/box.png") no-repeat;
      background-size:cover;
      position: relative;
      .timeout_info_wrapper_pic{
         width:182px;
         height:48px;
         background:url("../../assets/images/jigsaw/prompt.png") no-repeat;
         background-size:cover;
         position: absolute;
         text-align: center;
         line-height:38px;
         left:52px;
         top:-24px;
         color:#fff;
         font-size:16px;
         font-weight:400;
      }
      p{
         margin:34px auto 0;
         width:224px;
         height:66px;
         color:#666;
         font-size:16px;
         font-weight:400;
         font-family: PingFangSC-Regular, PingFang SC;
         line-height:22px;
         text-align: center;
      }
      .timeout_info_wrapper_btns{
         margin:17px auto 0;
         width:116px;
         height:32px;
         line-height:28px;
         color:#fff;
         background: url("../../assets/images/jigsaw/btn.png") no-repeat;
         background-size:cover;
         text-align: center;
      }
   }
}
</style>